<template>
  <v-card class="back" style="height: 480px">
    <v-layout column fill-height>
      <scroll-area>
        <template slot="header">
          <v-toolbar dark color="secondary" dense>
            <v-toolbar-title>
              <span class="body-2 text-uppercase">{{$t('add to')}} {{getData.cls == 'slot' ? 'слот ' + getData.name : getData.name}} </span>
            </v-toolbar-title>
          </v-toolbar>
        </template>

        <template slot="body">
          <v-layout column fill-height justify-start pa-2>
            <v-select :data-testid="$options.name + 'v-select' + 'model.template'"
              v-model="model.template"
              light
              :items="getItems"
              :label="$t('select module')"
              :hint="model.size ? model.size + ' ' + $t('available') : ''"
              single-line
              hide-details
              flat
              class="white"
              background-color="white"
              :height="54"
              clearable
            >
            </v-select>
          </v-layout>
        </template>

        <template slot="footer">
          <v-layout fill-height>
            <v-layout fill-height justify-end>
              <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" small @click="() =>{$emit('close')}" color="grey">{{$t('cancel')}}</v-btn>
              <v-btn :data-testid="$options.name + 'v-btn' + 'onAdd'" v-show="getTemplate" dark small @click="() => onAdd()" color="green">{{$t('add')}}</v-btn>
            </v-layout>
          </v-layout>
        </template>

      </scroll-area>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'

// Типы для данных
interface AddCardData {
  $id?: string
  compatible?: any[]
  slot_size?: number
  [key: string]: any
}

interface ModelData {
  items: any[]
  size: number
  template: string | null
}

export default Vue.extend({
  name: 'ADD_CARD',

  components: {
    scrollArea
  },

  props: {
    data: {
      type: Object as () => AddCardData,
      default: () => ({})
    },
  },

  data(): {
    model: ModelData
  } {
    return {
      model: {
        items: [],
        size: 0,
        template: null
      }
    }
  },

  computed: {
    getData(): AddCardData {
      return this.data
    },
    getItems(): any[] {
      return this.model.items
    },
    getTemplate(): string | null {
      return this.model.template
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.prepareData()
    },

    prepareData(): void {
      this.model = {
        items: [],
        size: 0,
        template: null
      }
      this.$set(this.model, 'items', this.getData.compatible || [])
      this.$set(this.model, 'size', this.getData.slot_size || 0)
    },

    async onAdd(): Promise<void> {
      console.log(this.$options.name, 'onAdd', this.model)
      if (!this.model.template) return
      
      try {
        const obj$ = await this.$bridge.getObjectById(this.getData.$id)
        console.log(this.$options.name, 'onAdd', 'obj$', obj$)
        
        if (obj$) {
          const cls$ = 'module'
          const data$ = {
            template: this.model.template,
            internal: true,
            name: `${this.model.template}_$${Math.round(Math.random() * 10000000000)}`
          }
          const c = await obj$.createChild(cls$, data$)
          if (c) {
            this.$dialog.notify.success(`Успешно добавлено`, {
              timeout: 5000
            })
            console.log(this.$options.name, 'onAdd', 'c', c)
            this.$emit('update')
            this.$emit('close')
          } 
          else {
            this.$dialog.notify.error('Ошибка добавления', { timeout: 5000 })
            return
          }
        }
      } catch (err) {
        console.error('onAdd', 'SMTH WRONG', err)
        this.$errorHandler(err)
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
